import { Component, Host, Prop, State, h } from '@stencil/core';
import { AppService } from '../../services';

@Component({
  tag: 'rcm-secondary-navigation',
  styleUrl: 'rcm-secondary-navigation.scss',
  shadow: true,
})
export class RcmSecondaryNavigation {
  @Prop() secondaryNavigationItems: string;

  @State() secondaryNavigation: any;

  @Prop() countryCode: string;

  getCorrectNavigation() {
    if (!this.secondaryNavigationItems) return;

    const parsedNavigation = JSON.parse(this.secondaryNavigationItems).NavigationItems.items;
    const filteredNavigation = parsedNavigation.filter((item) => item.full_slug.split('/')[0] === this.countryCode);
    this.secondaryNavigation =
      filteredNavigation === undefined || filteredNavigation.length < 1
        ? null
        : this.getNavigationByUserType(filteredNavigation[0], AppService.getUserType());
  }

  getNavigationByUserType(navigation: any, userType: string) {
    return userType === 'retail' ? navigation.content.secondary_nav_items_retail : navigation.content.secondary_nav_items_institutional;
  }

  render() {
    this.getCorrectNavigation();
    const componentsToRender = this.secondaryNavigation?.map((item) => {
      return <rcm-secondary-nav-item key={item.link_text} link_text={item.link_text} icon={item.icon} redirect_link={item.redirect_link} />;
    });
    return (
      <Host>
        <slot>{this.secondaryNavigation && componentsToRender}</slot>
      </Host>
    );
  }
}
